<div class="flex flex-col h-full">
    
    <div class="flex-none h-16">
        <ng-content select="#header"></ng-content>
    </div>

    <div class="grow">
        <ng-content></ng-content>
    </div>

    <div class="flex-none h-16">
        
    </div>

</div>
